import React from "react";
import { useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from "reactstrap";
import { getTranslation, UserProfileSidebarLanguages } from "../language";

function ModalTeamUnassignment({
  toggleTeamUnassignment,
  modal,
  saveTeamUnassignment,
  contactSelected,
  unassignLoading,
  unassignError,
}) {
  const stateLoadingGeneral = useSelector((state) => state.General.loading);
  const language = useSelector((state) => state.Group.language);

  const translate = (key) => getTranslation(UserProfileSidebarLanguages, language, key);

  return (
    <Modal
      isOpen={modal}
      centered
      className={stateLoadingGeneral ? "loadingLocked__modal__blur" : ""}
      toggle={toggleTeamUnassignment}
    >
      <ModalHeader toggle={toggleTeamUnassignment}>
        {translate("Release to team")}
      </ModalHeader>
      <ModalBody>
        {unassignError && (
          <Alert color="danger" className="mb-3">
            {unassignError}
          </Alert>
        )}
        {translate("This action will release the contact from the agent but will continue to belong to the team")}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={saveTeamUnassignment} disabled={unassignLoading}>
          {unassignLoading ? translate("Releasing...") : translate("Continue")}
        </Button>
        <Button color="secondary" onClick={toggleTeamUnassignment} disabled={unassignLoading}>
          {translate("Cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalTeamUnassignment;
